import request from "@/utils/request";

export function apiWorkbench() {
  return request.get("/workbench/index");
}
